import {
  BookingOnboardingDto,
  UpdateBookingOnboardingDto,
} from '../core/booking-onboarding';
import { HttpClient } from './http';
import { catch404ReturnNull } from './util';

export interface BookingOnboardingService {
  get: () => Promise<BookingOnboardingDto | null>;
  update: (
    updateDto: UpdateBookingOnboardingDto,
  ) => Promise<BookingOnboardingDto>;
  // Multipart: callers whose http client JSON-stringifies (booking-addon) must not use it.
  saveBookingBranding: (formData: FormData) => Promise<BookingOnboardingDto>;
}

export function createBookingOnboardingService(
  httpClient: HttpClient,
  baseUrl: string,
): BookingOnboardingService {
  return {
    get: () => {
      return catch404ReturnNull(() =>
        httpClient<BookingOnboardingDto>(
          `${baseUrl}/booking-onboarding`,
          'get',
        ),
      );
    },
    update: (updateDto: UpdateBookingOnboardingDto) => {
      return httpClient<BookingOnboardingDto>(
        `${baseUrl}/booking-onboarding`,
        'patch',
        {
          body: updateDto,
        },
      );
    },
    saveBookingBranding: (formData: FormData) => {
      return httpClient<BookingOnboardingDto>(
        `${baseUrl}/booking-onboarding/branding`,
        'put',
        {
          body: formData,
        },
      );
    },
  };
}
